import React, { useState } from 'react';

import PhotoModal from '../modals/PhotoModal'

export default function PhotoGallery() {

    const [photoModal, photoModalOpened] = useState(false);
    const [photo, photoSelected] = useState();

    const [photoGallery] = useState([
        {
            name: 'My White Stallion',
            category: 'featured',
            description: "This is my GSX-R 600. The fastest I dared to go on the way to the salt falts was 166 mph. It is a smooth ride",
            application: false,
            link: "https://raw.githubusercontent.com/CastroOlympias/react-portfolio/main/src/assets/images/photo-gallery/large-size/0.jpg"
        },
        {
            name: 'Red Pine Lake',
            category: 'featured',
            description: "IIRC, this is red pine lake",
            application: false,
            link: "https://raw.githubusercontent.com/CastroOlympias/react-portfolio/main/src/assets/images/photo-gallery/large-size/1.jpg"
        },
        {
            name: 'Nice and Toasty by the fire',
            category: 'featured',
            description: "It was a good and relaxing night by the fire. Imagine it and make it happen again",
            application: false,
            link: "https://raw.githubusercontent.com/CastroOlympias/react-portfolio/main/src/assets/images/photo-gallery/large-size/2.jpg"
        },
        {
            name: 'Like a Black Widow',
            category: 'featured',
            description: "This was a spider who's shape was like that of a Black Widow, it could poisounous, but I don't know",
            application: false,
            link: "https://raw.githubusercontent.com/CastroOlympias/react-portfolio/main/src/assets/images/photo-gallery/large-size/3.jpg"
        },
        {
            name: 'A war against the broker team',
            category: 'featured',
            description: "There was a war with the brokerage team, lets just say they lost and, jared, took most of the hits",
            application: false,
            link: "https://raw.githubusercontent.com/CastroOlympias/react-portfolio/main/src/assets/images/photo-gallery/large-size/4.jpg"
        },
        {
            name: 'Lake Blanche night',
            category: 'featured',
            description: "IIRC this is Lake Blanche, the 3 water sheads in the mountains, peaking over at Salt lake City",
            application: false,
            link: "https://raw.githubusercontent.com/CastroOlympias/react-portfolio/main/src/assets/images/photo-gallery/large-size/5.jpg"
        },
        {
            name: 'At Red Flower',
            category: 'featured',
            description: "A bush by the house with Red Flowers",
            application: false,
            link: "https://raw.githubusercontent.com/CastroOlympias/react-portfolio/main/src/assets/images/photo-gallery/large-size/6.jpg"
        },
        {
            name: 'At Lake Blanche',
            category: 'featured',
            description: "I think this was at Lake Blanche too",
            application: false,
            link: "https://raw.githubusercontent.com/CastroOlympias/react-portfolio/main/src/assets/images/photo-gallery/large-size/7.jpg"
        },
        {
            name: 'Puppet',
            category: 'featured',
            description: "Her name is Charly, but I call her Puppet or Pluppy. She's ankle biter, and heates long sleeve shirts. She like to chase the other dogs while they chase they toys, then she bites their ankles",
            application: false,
            link: "https://raw.githubusercontent.com/CastroOlympias/react-portfolio/main/src/assets/images/photo-gallery/large-size/8.jpg"
        },
        {
            name: 'Inside the Capital',
            category: 'featured',
            description: "Salt Lake City Captical",
            application: false,
            link: "https://raw.githubusercontent.com/CastroOlympias/react-portfolio/main/src/assets/images/photo-gallery/large-size/9.jpg"
        },
        {
            name: 'Lucy',
            category: 'featured',
            description: "She wants my pickle tuna sandwich",
            application: false,
            link: "https://raw.githubusercontent.com/CastroOlympias/react-portfolio/main/src/assets/images/photo-gallery/large-size/10.jpg"
        },
        {
            name: 'Zion National Park',
            category: 'featured',
            description: "I created a Karen with a pinecone on top, on the way to observation point, I think it is called, can't remember which is why I should go back",
            application: false,
            link: "https://raw.githubusercontent.com/CastroOlympias/react-portfolio/main/src/assets/images/photo-gallery/large-size/11.jpg"
        },
        {
            name: 'Zion National Park HDR',
            category: 'featured',
            description: "Somewhere in the corner on the way to somewhere in Zion, this picture was taken by a Nokia Lumia 1520, a Windows phone with a 20 megapixlel camera",
            application: false,
            link: "https://raw.githubusercontent.com/CastroOlympias/react-portfolio/main/src/assets/images/photo-gallery/large-size/12.jpg"
        },
    ])


    const openPhotoModal = (image, i) => {
        const photoModalUnderlayer = document.getElementById('Photo-Modal-Underlayer')
        const photoModalImage = document.getElementById('Photo-Modal-Image')
        if (photoModal === false) {
            photoSelected({ ...image, index: i })
            photoModalOpened(!photoModal);
        } else {
            photoModalUnderlayer.className = 'Photo-Modal-Underlayer-Closed'
            photoModalImage.className = 'PhotoModal-Section-Position PhotoModal-Photo-Section-Dimensions-Closed'
            setTimeout(() => {
                photoModalOpened(!photoModal);
            }, 285);
        }
    }

    const directory = 'photo-gallery'

    return (
        <>
            {/* <div id="HomeRoute-Header" className='HomeRoute-Header-Title-Section-Dimensions HomeRoute-Header-Title-Section-Position'>
                <button id='Photo-Gallery-Header-Title' className='HomeRoute-Header-Color HomeRoute-Header-Animation-Open HomeRoute-Header-Dimensions HomeRoute-Header-Shape'>
                    <h1>Photo Gallery</h1>
                </button>
            </div> */}

            {photoModal &&
                <>
                    <section onClick={openPhotoModal} id="Photo-Modal-Underlayer" className='Photo-Modal-Underlayer-Opened'>
                    </section>
                    <PhotoModal directory={directory} currentPhoto={photo} closePhotoModal={photoModalOpened} closeIt={openPhotoModal} />
                </>
            }

            <div className='Content-Section-Position Content-Section-Shape Content-Section-Color Content-Section-Dimesions'>

                {photoGallery.map((image, i) => (

                    <img
                        className='Photos-Dimensions Photos-Shape PhotoModal-Photo-Animations-Opened'
                        id={photoGallery[i].name}
                        src={require(`../../../../assets/images/${directory}/1440/${i}.jpg`)}
                        alt={image.name}
                        key={image.name}
                        onClick={() => openPhotoModal(image, i)}
                    />
                ))}
            </div>
            </>
    )
}